import { render, staticRenderFns } from "./DeleteStage.vue?vue&type=template&id=598ed98c&"
import script from "./DeleteStage.vue?vue&type=script&lang=js&"
export * from "./DeleteStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports